export interface IColors {
  accent: string
  accentFocused: string
  accentThin: string
  black: string
  blue: string
  gray: string
  green: string
  licensePlateBlue: string
  lightGray: string
  lightGreen: string
  orange: string
  pink: string
  primary: string
  primaryDark: string
  primaryLight: string
  red: string
  secondary: string
  secondaryLight: string
  secondaryThin: string
  secondaryThinLight: string
  white: string
}

export const Colors: IColors = {
  accent: '#FF8200',
  accentFocused: '#e2790b',
  accentThin: 'black',
  black: '#333333',
  blue: '#4A90E2',
  gray: '#c0c0c0',
  green: '#4C9C2E',
  licensePlateBlue: '#003399',
  lightGray: '#f5f5f5',
  lightGreen: '#EAF4F4',
  orange: '#FF8200',
  pink: '#f5d2d7',
  primary: '#004851',
  primaryDark: '#003C43',
  primaryLight: '#527A7F',
  red: '#D0021B',
  secondary: '#00968F',
  secondaryLight: '#12A49E',
  secondaryThin: '#00968F08',
  secondaryThinLight: '#D9F0EE',
  white: '#ffffff'
}
